import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import ProjectForm from './components/ProjectForm';
import ProjectsDashboard from './components/ProjectsDashboard';
import ProjectDetails from './components/ProjectDetails';
import { ToastProvider } from './components/ToastContext';
import ProjectEdit from './components/ProjectEdit';
import Gallery from './components/Gallery';
import PackagesDashboard from './components/PackagesDashboard';
import PackageEdit from './components/PackageEdit';

function App() {
  return (
    <Router>
      <ToastProvider>
        <div className="App">
          <Routes>
            <Route path="/" element={<ProjectForm />} />
            <Route path="/dashboard" element={<ProjectsDashboard />} />
            <Route path="/project/:id" element={<ProjectDetails />} />
            <Route path="/project/:id/edit" element={<ProjectEdit />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/packages" element={<PackagesDashboard />} />
            <Route path="/packages/:id/edit" element={<PackageEdit />} />
          </Routes>
        </div>
      </ToastProvider>
    </Router>
  );
}

export default App;
